import { features } from './features'; 

features.applicationType = 'viverogest';

// FITOGEST
features.showMotivoFito = true;
features.showPartida = true;
features.puedeImprimir = true;
features.showRegistroTratamiento = true;
features.showEnviarWhatsapp = false;
features.showEnviarCorreo = true;
features.showEnviarWhatsappVisitas = false;
features.showEnviarCorreoVisitas = true;
features.showTareasBio = false;
features.showTareasOtrosDuracion = false;

// AGROGEST
features.showAplicadoresFichajes = false;
features.showAplicadoresPartes = false;
features.showTrabajadoresCargos = true;
features.showTareasOtros = true;
features.showCostes = false;
features.hasClients = false;
features.showStock = true;
features.showSectorPlantas = false;
features.showProductosNumReg = false;
features.fertilizantesNombreRequired = true;
features.fertilizantesUdsMedidaRequired = true;
features.showVisitasConsultas = true;
features.showVisitas = true;
features.showHistoricoFT = false;
features.showExepcionales = false;
features.showOtrasDenominaciones = false;
features.showRecetaAgrogest = true;
features.showRecetaFertiAgrogest = true;
features.showMapas = true;
features.showMapaRutas = true;
features.showAnalisis = false;
features.showFertilizantesAlbaranFactura = true;
features.showStockMotivo = true;
features.showStockTipoDeDato = true;
features.showStockSemilla = true;
features.showStockUbicacion = true;
features.showReto = false;
features.showSigPacParcela = false;
features.showStockSemillasColsDistribution = 3;
features.showStockMarcaComercial = true;
features.showWidthFertilizanteNombre = true;
features.canDuplicateFinca = true;
features.showVisitasConsultasObservaciones = true;
features.showParcelasSector = false;
features.showTareasFitoMaquinarias = true;
features.showFertilizantesParcelas = true;

// BUSINESS INTELLIGENCE
features.showEstadisticas = true;
features.showUsuariosLogs = true;
export const environment = {
    production: true,
    v: '2',
    serverUrl: 'https://bravosol.viverogest.com/',
    logoUrl: 'assets/logo_bravosol.png',
    appName: 'bravosol',
    features: features
};
